import { SlidingStatBar } from 'app/layouts/stats/sliding';
import { getRelativeTimeStampRange } from 'app/shared/utils/date';
import { useContactService } from 'hooks/users/contact';
import { useMailActionService } from 'hooks/mailaction';
import React, { useEffect, useState } from 'react';
import { RelativeStatCard } from 'app/shared/cards/stat/relative';

export const ContactStatBar = () => {
  const { fetchContacts } = useContactService();
  const { fetchMailActions } = useMailActionService();

  const [stats, setStats] = useState({
    created_all_time: 0,
    created_this_month: 0,
    created_last_month: 0,
    invalid_all_time: 0,
    invalid_this_month: 0,
    invalid_last_month: 0,
    unsubscriptions_all_time: 0,
    unsubscriptions_this_month: 0,
    unsubscriptions_last_month: 0,
    active_all_time: 0,
    active_this_month: 0,
    active_last_month: 0
  });

  useEffect(() => {
    const { this_month, last_month } = getRelativeTimeStampRange();
    Promise.all([
      fetchContacts({ query_string: `count=1` }),
      fetchContacts({ query_string: `time_stamp=${this_month.start}~${this_month.end}&count=1` }),
      fetchContacts({ query_string: `time_stamp=${last_month.start}~${last_month.end}&count=1` }),
      fetchContacts({
        query_string: `bool=-is_valid&count=1`
      }),
      fetchContacts({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&bool=-is_valid&count=1`
      }),
      fetchContacts({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&bool=-is_valid&count=1`
      }),
      fetchContacts({
        query_string: `bool=is_unsubscribed&count=1`
      }),
      fetchContacts({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&bool=is_unsubscribed&count=1`
      }),
      fetchContacts({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&bool=is_unsubscribed&count=1`
      }),
      fetchMailActions({
        query_string: `action=opened,clicked_link&group_by=recipient_id&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&action=opened,clicked_link&group_by=recipient_id&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&action=opened,clicked_link&group_by=recipient_id&count=1`
      })
    ]).then((responses) => {
      const [
        { size: created_all_time },
        { size: created_this_month },
        { size: created_last_month },
        { size: invalid_all_time },
        { size: invalid_this_month },
        { size: invalid_last_month },
        { size: unsubscriptions_all_time },
        { size: unsubscriptions_this_month },
        { size: unsubscriptions_last_month },
        { size: active_all_time },
        { size: active_this_month },
        { size: active_last_month }
      ] = responses;
      setStats({
        created_all_time,
        created_this_month,
        created_last_month,
        invalid_all_time,
        invalid_this_month,
        invalid_last_month,
        unsubscriptions_all_time,
        unsubscriptions_this_month,
        unsubscriptions_last_month,
        active_all_time,
        active_this_month,
        active_last_month
      });
    });
  }, []);

  const statDetails = [
    {
      label: 'New contacts',
      main_value: stats.created_all_time,
      current_value: stats.created_this_month,
      previous_value: stats.created_last_month
    },
    {
      label: 'Active contacts',
      main_value: stats.active_all_time,
      current_value: stats.active_this_month,
      previous_value: stats.active_last_month
    },
    {
      label: 'Invalid contacts',
      main_value: stats.invalid_all_time,
      current_value: stats.invalid_this_month,
      previous_value: stats.invalid_last_month
    },
    {
      label: 'Unsubscriptions',
      main_value: stats.unsubscriptions_all_time,
      current_value: stats.unsubscriptions_this_month,
      previous_value: stats.unsubscriptions_last_month
    }
  ];

  return (
    <>
      <SlidingStatBar>
        {statDetails.map((stat, index) => (
          <RelativeStatCard
            key={index}
            title={stat.label}
            period={'month'}
            main_value={stat.main_value}
            current_value={stat.current_value}
            previous_value={stat.previous_value}
          />
        ))}
      </SlidingStatBar>
    </>
  );
};
